import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { Grid } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import MUITableLoading from 'components/MUITableLoading/MUITableLoading';
import Layout from 'components/Layout/Layout';
import { GET_PRODUCT_TYPES } from '../../../../queries/products/productType';
import DrawerNative from '../../../../components/DrawerNative';
import PageError from '../../../../components/PageError';
import PageTitle from '../../../../components/PageTitle/PageTitle';
import { Update } from './edit';
import { AddProductTypes } from './create';
import DeleteProductTypes from './delete';

export default function ProductTypesContent() {
  const [productTypes, setProductTypes] = useState([]);
  const queryProductTypes = useQuery(GET_PRODUCT_TYPES, {
    fetchPolicy: 'network-only',
  });
  const { loading, error, refetch } = queryProductTypes;
  const refetchProductTypes = refetch;

  useEffect(() => {
    if (queryProductTypes.data) {
      const { data } = queryProductTypes;
      setProductTypes(data.listProductTypes);
    }
  }, [queryProductTypes]);

  const toolbar = (selectedRows) => (
    <Grid container spacing={0} item xs={9} alignItems="flex-start" justify="flex-end" direction="row">
      <Grid item xs={1}>
        <DeleteProductTypes selectedRows={selectedRows} productTypes={productTypes} refetch={refetchProductTypes} />
      </Grid>
    </Grid>
  );

  const options = {
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    responsive: 'standard',
    customToolbarSelect: toolbar,
  };

  const ActionsRow = (tableMeta) => {
    const name = tableMeta.rowData[0];
    const id = tableMeta.rowData[1];
    const disclaimer = tableMeta.rowData[2];
    const dynamicFields = tableMeta.rowData[3];
    const disclaimerByLanguage = tableMeta.rowData[4];
    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <DrawerNative title="Edit Product Types" iconButtonAction={false} labelButtonAction={name} showBtn width="50%">
            <Update
              id={id}
              name={name}
              disclaimer={disclaimer}
              dynamicFields={dynamicFields}
              disclaimerByLanguage={disclaimerByLanguage}
              refetch={refetchProductTypes}
            />
          </DrawerNative>
        </Grid>
        <Grid item xs={6} />
      </Grid>
    );
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Product Types" />
        </Grid>
        <Grid item xs={2}>
          <DrawerNative title="ProductTypes" labelButtonAction="Add" showBtn width="50%">
            <AddProductTypes refetch={refetchProductTypes} />
          </DrawerNative>
        </Grid>
      </Grid>
      {
        (loading) ? <MUITableLoading columns={['NAME', 'DISCLAIMER']} />
          : (error) ? <PageError />
            : (
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <MUIDataTable
                    title={false}
                    data={productTypes}
                    columns={[{
                      name: 'name',
                      label: 'NAME',
                      options: {
                        customBodyRender: (value, tableMeta) => {
                          return (ActionsRow(tableMeta));
                        },
                        empty: true,
                        filter: true,
                        sort: true,
                      },
                    },
                    {
                      name: 'id',
                      label: 'ID',
                      options: {
                        display: false,
                      },
                    },
                    {
                      name: 'disclaimer',
                      label: 'DISCLAIMER',
                      options: {
                        display: true,
                      },
                    },
                    {
                      name: 'dynamicFields',
                      label: 'DYNAMIC FIELDS',
                      options: {
                        display: false,
                      },
                    },
                    {
                      name: 'disclaimerByLanguage',
                      label: 'DISCLAIMER BY LANGUAGE',
                      options: {
                        display: false,
                      },
                    },
                    ]}
                    options={options}
                  />
                </Grid>
              </Grid>
            )
      }
    </Layout>
  );
}
